import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 12C5.463 12 1 13.15 1 17v1h17v-1c0-3.85-4.463-5-8.5-5zM9.5 11c2.485 0 4.5-2.015 4.5-4.5S11.985 2 9.5 2 5 4.015 5 6.5 7.015 11 9.5 11z',
  ],
  height: 20,
  width: 20,
});
